import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '@Common/models/redux/store';
import { makeStyles } from '@mui/styles';
import { Typography } from '@quillbot/design-system';
import { CHAR_LIMITS } from 'config/constants';
import clsx from 'clsx';
import Link from 'next/link';
import { numberFormatter } from 'core/utils';
import WordSummary from '@Common/components/WordSummary';
import { numberWithCommas } from '@Common/handlers/helper';

interface IProps {
  value: number;
  limit: number;
}

function CharacterSummary(props: IProps) {
  let wordLimit = props.limit;
  const value = props.value;
  const inputCharLength = useSelector((state: RootState) => state.smzr.input.numberOfChars);

  const useStyles = makeStyles((theme) => ({
    stdFontsize: {
      fontSize: '13px',
    },
    blueText: {
      color: theme.specialColors.BLUE_COLOR,
      fontWeight: 600,
      cursor: 'pointer',
    },
  }));

  const classes = useStyles(props);
  const showCharLimitMessage = useSelector(
    (state: RootState) => state.smzr.controls.showCharLimitMessage
  );
  let nextWordLimit = CHAR_LIMITS.SUMMARIZER_WORD_LIMIT_MEMBER;
  const user = useSelector((state: RootState) => state.user);
  if (user && user.isAuthenticated) {
    wordLimit = CHAR_LIMITS.SUMMARIZER_WORD_LIMIT_MEMBER;
    nextWordLimit = CHAR_LIMITS.SUMMARIZER_WORD_LIMIT_PREMIUM;
  }
  if (user && user.premium) {
    wordLimit = CHAR_LIMITS.SUMMARIZER_WORD_LIMIT_PREMIUM;
  }

  const topLevelText = () => {
    if (user.premium) {
      return (
        <Typography className={classes.stdFontsize}>
          {`Only ${numberWithCommas(CHAR_LIMITS.SUMMARIZER_WORD_LIMIT_PREMIUM)} words can be
          processed at one time.`}
        </Typography>
      );
    }

    return (
      <Typography className={classes.stdFontsize}>
        {user?.isAuthenticated ? (
          <a target="_blank" href="/premium?referrer=summarizerWordLimit">
            <span className={clsx(classes.blueText, 'login-offer-text')}>Buy Premium</span>
          </a>
        ) : (
          <Link
            href={{
              pathname: '/signup',
              query: { referrer: 'summarizerWordLimit' },
            }}
          >
            <a className={clsx('login-offer-text', classes.blueText, 'pl-0')}>Sign Up</a>
          </Link>
        )}
        <span> for {numberFormatter(nextWordLimit)} words.</span>
      </Typography>
    );
  };

  return (
    <WordSummary
      wordCount={value}
      showCharLimitMessage={showCharLimitMessage}
      wordLimit={wordLimit}
      topLevelComponent={topLevelText()}
      characterCount={inputCharLength}
    />
  );
}

export default CharacterSummary;
